import { useModulePermissions } from "@/context/ModulePermissionsContext";

/** True when this user has the company demo toolbar flag (tenant must have a registered demo pack). */
export function useCompanyDemoBarEnabled(): boolean {
  const { permissions } = useModulePermissions();
  return Boolean(permissions?.show_company_demo_bar);
}
